<template>
<div id="login-box">
    <layout-customs>
        <!-- Page Content -->
        <div class="login-box">
            <div class="">
              <section class="header">       
                <div class="logo">
                  <a class="navbar-brand" href="index.html"><img src="/static/dist/images/Greeneum Logo.png"></a>
                  <div class="page-header">Greeneum Marketplace</div>
                </div>
                <div class="header-buttons">
                  <a href="#" class="explore-btn">Explore Marketpalce</a>
                  <a href="login" class="signin-btn">Sign In</a>
                </div>
            </section>
            <section class="main">
                <div class="row">
                    <h1>Trade Renewable Energy with <span class="green">Green Tokens</span></h1>
                     <p>
                        The first blockchain-powered marketplace for renewable energy certificates and carbon credits, powered by Green Tokens (GT) and secured by Solana technology.
                      </p>

                      <div class="main-buttons">
                        <button class="start-btn"><a href="login">Start Trading Today</a></button>
                        <button class="view-btn"><a href="login">View Marketplace</a></button>
                      </div>

                      <div class="stats">
                        <div class="stat">
                          <h2>1.8M GT</h2>
                          <p>Trading Volume</p>
                        </div>
                        <div class="stat">
                          <h2>15+</h2>
                          <p>Active Projects</p>
                        </div>
                        <div class="stat">
                          <h2>143k</h2>
                          <p>Tons CO₂ Offset</p>
                        </div>
                        <div class="stat">
                          <h2>234+</h2>
                          <p>Active Traders</p>
                        </div>
                      </div>
                </div>
            </section>  
            <section class="middle">
              <h1>Why Choose Greeneum?</h1>
              <h2>Advanced blockchain technology meets environmental sustainability</h2>

              <div class="features">
                <div class="feature">
                  <i><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
  <path d="M 21.318 71.671 c 2.459 -20.209 18.716 -33.875 33.192 -39.994 C 35.258 48.541 27.242 63.394 25.548 90 h 4.772 c 0.068 -5.109 0.74 -9.877 1.858 -14.393 c 16.66 1.308 30.312 -3.716 38.722 -18.74 C 80.738 35.723 71.282 17.757 60.561 0 c -1.096 19.923 -33.438 24.956 -39.945 49.585 c -1.374 5.199 -2.361 10.225 -2.913 15.216" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(127,178,65); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
  <path d="M 21.844 49.905 C 32.338 26.894 61.111 20.591 60.561 0 c -3.055 15.979 -26.319 15.979 -38.303 31.958 c -6.862 9.601 -9.917 20.161 -4.555 32.844 C 18.255 59.81 19.726 54.847 21.844 49.905 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(113,156,64); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
</g>
</svg></i>
                  <h3>Green Tokens</h3>
                  <p>Native cryptocurrency designed specifically for sustainable energy trading</p>
                </div>
                <div class="feature">
                  <i><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
  <path d="M 45 79.714 C 28.181 73.53 16.567 55.678 16.567 35.685 V 21.967 C 22.307 20.273 26.84 15.739 28.534 10 H 45 c 2.966 -2.393 2.375 -5.914 0 -10 H 24.254 c -2.761 0 -5 2.239 -5 5 c 0 4.238 -3.448 7.687 -7.687 7.687 c -2.761 0 -5 2.239 -5 5 v 17.998 c 0 24.89 15.178 47.127 36.91 54.078 C 43.972 89.921 44.486 90 45 90 C 47.648 86.782 47.693 83.357 45 79.714 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(105,200,226); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
  <path d="M 45 79.714 c 16.819 -6.184 28.433 -24.036 28.433 -44.029 V 21.967 C 67.693 20.273 63.16 15.739 61.466 10 H 45 V 0 h 20.746 c 2.761 0 5 2.239 5 5 c 0 4.238 3.448 7.687 7.687 7.687 c 2.761 0 5 2.239 5 5 v 17.998 c 0 24.89 -15.178 47.127 -36.91 54.078 C 46.028 89.921 45.514 90 45 90 V 79.714 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(91,177,201); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/>
</g>
</svg></i>
                  <h3>Blockchain Security</h3>
                  <p>Solana-powered transparent and immutable transaction records</p>
                </div>
                <div class="feature">
                  <i><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
  <polygon points="71.43,35.12 50.46,39.15 54.52,0 32.06,46.25 42.64,50.54 35.48,90 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(234,211,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
  <polygon points="54.52,0 34.48,46.53 48.22,44.15 35.48,90 39.54,50.85 18.57,54.88 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(198,179,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
</g>
</svg></i>
                  <h3>Global Projects</h3>
                  <p>Access renewable energy projects from USA, Brazil, Argentina, and beyond</p>
                </div>
                <div class="feature">
                  <i class="i-charts"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">
<g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
  <rect x="9.54" y="0.51" rx="0" ry="0" width="2.02" height="88.99" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) "/>
  <rect x="0" y="77.94" rx="0" ry="0" width="90" height="2.02" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) "/>
  <polygon points="20.94,56.87 19.51,55.44 37.71,37.24 53.03,50.55 88.27,15.3 89.7,16.73 53.12,53.32 37.81,40 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
  <polygon points="90,26.3 87.98,26.3 87.98,17.03 78.71,17.03 78.71,15.01 90,15.01 " style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>
</g>
</svg></i>
                  <h3>Real-time Trading</h3>
                  <p>Advanced trading tools with live market data and analytics</p>
                </div>
              </div>
            </section>

              <section class="cta">
                <h2>Ready to Make a Difference?</h2>
                <p>Join the Greeneum community and start trading renewable energy certificates with Green Tokens today.</p>
                <button>Get Started Now</button>
              </section>  

              <section class="footer">  
                <div class="head">              
                  <img src="/static/dist/images/Greeneum Logo.png" alt="Greeneum logo"> 
                  <h1>Greeneum Marketplace</h1>             
                </div>  

                <div class="footer-content">
                  <h2>Leading blockchain-powered marketplace for renewable energy certificates and carbon credits</h2>
                </div>
              </section>  
            </div>
        </div>
    </layout-customs>
</div>
</template>
<style>
.fa-eye, .fa-eye-slash {
    position: absolute;
    right: -16px;
    top: 10px;
    font-size: 18px;
    color: #55be68;
    background: #fff;
    padding: 4px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  background-color: #fcfefd;
  border-bottom: 1px solid #bbf7d0;
}
.logo a { float:left; }   
.logo {
  font-weight: bold;
  font-size: 20px;
  display: inline-flex;
}
.logo span, .logo div {
  color: #333;
}
.navbar-brand img {
    max-width: 180px;
    height: 40px;
}
.page-header {
  padding-top: 24px; 
  margin-left: 20px;
  font-weight: 700;
  font-size: 20px;
} 
.header-buttons a {
  margin-left: 10px;
  padding: 10px 16px;
  font-size: 14px;  
  border-radius: 6px;
  cursor: pointer;
}
.header-buttons a:focus, .header-buttons a:hover { color: #333; }
.explore-btn {
  background: white;
  border: 1px solid #ccc;
  color: #333;
}
.signin-btn {
  background: #28c667;
  color: white;
}
.main {
  padding: 60px 20px;
  background-color: #f0fdf4;
}
.main .row { text-align: center; }
.main h1 {
  font-size: 48px;
  font-weight: bold;
}
.main h1 .green {
  color: #28c667;
}
.main p {
  font-size: 18px;
  margin-top: 20px;
  color: #444;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
.main-buttons {
  margin-top: 30px;
}
.main-buttons button {
  margin: 10px;
  padding: 14px 24px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
}
.start-btn {
  background: #28c667;
  border: none;
  color: white;
}
.view-btn {
  background: white;
  border: 1px solid #eceeed;
}
.stats {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 60px;
  gap: 40px;
}
.stat {
  text-align: center;
}
.stat h2 {
  font-size: 28px;
  color: #28c667;
  margin: 0;
}
.stat p {
  margin-top: 8px;
  color: #555;
  font-size: 16px;
}
.middle { background-color: #ffffff; }
.middle h1, .middle h2 { 
  text-align: center; 
  margin: 0;
  padding-top: 20px;
}
h2 {
  margin-top: 10px;
  font-size: 18px;
  font-weight: normal;
  color: #555;
}
.features {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 40px 0;
  gap: 20px;
  margin-bottom: 0px;
  padding-bottom: 40px;
}
.feature {      
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  width: 220px;
  box-sizing: border-box;
  text-align: center;
  transition: box-shadow 0.3s ease;
}
.feature:hover {
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
.feature i {
  display: block;
  font-size: 24px;
  margin-bottom: 10px;
}
.feature svg { width: 24px;  height: 24px; }
.feature h3 {
  margin: 10px 0;
  font-size: 18px;
}
.feature p {
  font-size: 14px;
  color: #555;
}
.cta {
  background: linear-gradient(90deg, #22c55e, #3b82f6);
  color: white;
  text-align: center;
  padding: 50px 20px;
}
.cta h2 {
  font-size: 26px;
  margin-bottom: 20px;
  color: #fff;
}
.cta p {
  font-size: 16px;
  margin-bottom: 30px;
}
.cta button {
  background: white;
  color: #333;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
} 
.cta button:hover {
  background: #e5e5e5;
}
.footer {
  margin: 0;
  background-color: #111;
  color: #fff;
}
.footer .head {  
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #111;
  padding: 20px;
}
.footer img {
  width: 180px;
  height: 40px;
  margin-right: 15px;
}
.footer h1 {
  font-size: 28px;
  margin: 0;
  font-weight: bold;
  color: #fff;
}
.footer  p {
  font-size: 14px;
  margin: 0;
  color: #ccc;
}
.footer-content {
  padding: 50px 20px;
  text-align: center;
}
.footer-content h2 {
  font-size: 24px;
  margin-bottom: 20px;
} 
.footer img {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
}
</style>
<script>
import LayoutCustoms from './../../layouts/LayoutDefault.vue';
import Api from './../../services/api'
import User from './../../services/auth'

export default {
  name: 'project',
  props: [],
  components: {
    LayoutCustoms,
    Api,
    User
  },
  data() {
    return {
      isLogin: false,
      email: '',
      password: '',
      validationMessage: '',
      activationMessage: null,
      fbSignInParams: {
        scope: 'email,user_likes',
        return_scopes: true,
      },
      googleSignInParams: {
        client_id:
          '459260954938-kpc63h85vmpjr5ribmj74u15spiko6ns.apps.googleusercontent.com',
      },
      activated: false,
    }
  },
  methods: {
    async signIn() {
      try {
        var validation = await this.$validator.validateAll()
        if (!validation) {
          return
        }
        var response = await Api.signIn(this.email, this.password)
        this.isLogin = true;
        window.location.href = '/dashboard'
      } catch (error) {
        console.error(error)
        if (error.message) {
          this.validationMessage = error.message
        } else {
          this.validationMessage = 'Login or password is wrong.*****'
        }
      }
    },
    onAutoFill(me, callback) {
      var last = $(me).val()
      var infunc = function() {
        var text = $(me).val()
        if (text != last) {
          last = text
          callback(me)
          return
        }
        setTimeout(infunc, 100)
      }
      setTimeout(infunc, 100)
    },
  },
  created() {
    if (this.$route.path == '/twitter/callback') {
      this.$http.get('/access-token' + location.search).then(
        response => {
          User.setUserData(response.data.user)
          this.user = response.data.user.email
          this.$router.push('/dashboard')
        },
        error => {
          this.validationMessage = 'Problems with login. Try again.'
          console.error(error)
        }
      )
    }
    else  if (this.$route.path == '/linkedin') {
          // console.log(" search linkedin")
          var search = location.search.substring(1);
          var s = search.substr(search.indexOf("&image=http")+7, search.length)
          var data = search?JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
                 function(key, value) { return key===""?value:decodeURIComponent(value) }):{}
          var img = decodeURIComponent(s)
          data.image = img

          User.setUserData(data)
          this.user = data.email
          // this.$router.push('/dashboard')
    }
  },
  beforeMount() {
    if (User.isLogin()) {
      window.location.href = '/dashboard'
    }
  },
  mounted() {
    window.removeEventListener('resize', this.handleResize)
    if (this.$route.params.id) {
      this.$http.post('/activated', { token: this.$route.params.id }).then(
        response => {
          this.isLogin = true;
          this.activated = true;
          User.setUserData(response.data.user)
          this.activationMessage = '<div class="subtitle-1" style="font-weight: 500;color: white;">Email confirmed, Thank you.<br><a hreg="/">Enter</a> Energy platform.</div>'
        },
        error => {
          this.activationMessage = "Token expired, try to register again."
          console.log(error)
        }
      )
    }

  },
}
</script>



// WEBPACK FOOTER //
// src/components/Account/SignInNew.vue